import { ThemeSetting } from '../objects/ThemeObject';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var ThemeSettingService = /** @class */ (function () {
    function ThemeSettingService() {
        this.theme = new ThemeSetting();
        this.themeSettingSubject = new Subject();
        this.themeSettingChanged$ = this.themeSettingSubject.asObservable();
    }
    ThemeSettingService.prototype.setTheme = function (theme) {
        this.theme = theme;
        this.themeSettingSubject.next(theme);
    };
    ThemeSettingService.prototype.getTheme = function () {
        return this.theme;
    };
    ThemeSettingService.prototype.clearToaster = function () {
        this.theme = null;
    };
    ThemeSettingService.ngInjectableDef = i0.defineInjectable({ factory: function ThemeSettingService_Factory() { return new ThemeSettingService(); }, token: ThemeSettingService, providedIn: "root" });
    return ThemeSettingService;
}());
export { ThemeSettingService };
